import { render, staticRenderFns } from "./ScoreAdjustmentReview.vue?vue&type=template&id=0423440f&scoped=true&"
import script from "./ScoreAdjustmentReview.vue?vue&type=script&lang=js&"
export * from "./ScoreAdjustmentReview.vue?vue&type=script&lang=js&"
import style0 from "./ScoreAdjustmentReview.vue?vue&type=style&index=0&id=0423440f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0423440f",
  null
  
)

export default component.exports